var state = {
  cognitoInfo: {},
  loggedIn: false,
  loadingState: true,
  errorLoadingState: false,
  userEmail: "",
  userGroup: "",
  branchName: ""
}

function setLoggedIn(newValue) {
  state.loggedIn = newValue;
}

function setLoggedOut() {
  state.loggedIn = false;
  state.cognitoInfo = {};
}

function setCognitoInfo(newValue){
  state.cognitoInfo = newValue;
}

function setUserEmail(newValue){
  state.userEmail = newValue;
}

function setUserGroup(newValue){
  state.userGroup = newValue;
}

function setBranchName(newValue){
  state.branchName = newValue;
}

export default {
  state: state,
  setLoggedIn: setLoggedIn,
  setLoggedOut: setLoggedOut,
  setCognitoInfo: setCognitoInfo,
  setUserEmail: setUserEmail,
  setUserGroup: setUserGroup,
  setBranchName: setBranchName
}
